import React, { useEffect, useMemo, useState } from 'react';
import { Placeholder } from './Placeholder';
import { EDITING_COMPONENT_ID, EDITING_COMPONENT_PLACEHOLDER, RenderingType, } from '@sitecore-jss/sitecore-jss/layout';
import { DesignLibraryStatus, getDesignLibraryStatusEvent, addComponentUpdateHandler, } from '@sitecore-jss/sitecore-jss/editing';
9;
export const DesignLibrary = (layoutData) => {
    const { route } = layoutData.sitecore;
    const isDesignLibrary = layoutData.sitecore.context.renderingType === RenderingType.Component;
    if (!isDesignLibrary) {
        return React.createElement(React.Fragment, null);
    }
    const [renderKey, setRenderKey] = useState(0);
    const [rootUpdate, setRootUpdate] = useState(null);
    const rootComponent = route === null || route === void 0 ? void 0 : route.placeholders[EDITING_COMPONENT_PLACEHOLDER][0];
    // useEffect may execute multiple times on single render (i.e. in dev) - but we only want to fire ready event once
    let componentReady = false;
    // have an up-to-date layout state between re-renders (SSR re-render excluded)
    const persistedRoot = useMemo(() => (Object.assign(Object.assign({}, (rootComponent || {})), rootUpdate)), [
        rootComponent,
        rootUpdate,
    ]);
    route.placeholders[EDITING_COMPONENT_PLACEHOLDER][0] = persistedRoot;
    useEffect(() => {
        // useEffect will fire when components are ready - and we inform the whole wide world of it too
        if (!componentReady) {
            componentReady = true;
            window.top.postMessage(getDesignLibraryStatusEvent(DesignLibraryStatus.READY, rootComponent.uid), '*');
        }
        const unsubscribe = addComponentUpdateHandler(persistedRoot, (updatedRoot) => {
            setRootUpdate(Object.assign({}, updatedRoot));
            setRenderKey((key) => key + 1);
        });
        // useEffect will cleanup event handler on re-render
        return unsubscribe;
    }, []);
    useEffect(() => {
        // Send a rendered event only as effect of a component update command
        if (renderKey === 0) {
            return;
        }
        window.top.postMessage(getDesignLibraryStatusEvent(DesignLibraryStatus.RENDERED, rootComponent.uid), '*');
    }, [renderKey, rootComponent.uid]);
    return (React.createElement(React.Fragment, null,
        React.createElement("main", null,
            React.createElement("div", { id: EDITING_COMPONENT_ID }, route && (React.createElement(Placeholder, { name: EDITING_COMPONENT_PLACEHOLDER, rendering: route, key: renderKey }))))));
};
